import { apiRequest, storeSession } from "./client";
import { API_URL } from "@/config";

export const getLoginUrl = () => `${API_URL}/api/v1/auth/discord`;

export const getCurrentUser = () => apiRequest("/api/v1/auth/me");

export const getSessionGuilds = () => apiRequest("/api/v1/auth/guilds");

export const refreshSession = () => apiRequest("/api/v1/auth/refresh", { method: "POST" });

export const logout = () =>
  apiRequest("/api/v1/auth/logout", { method: "POST" }).finally(() => storeSession(null));

export const redirectToLogin = () => {
  window.location.href = getLoginUrl();
};
